<template>
  <TitleContentPage :page="$page" />
</template>

<script>
import { TitleContentPage } from '@/components/templates'
import { PageMetaMixin } from '@/mixins'

export default {
  name: 'Privacy',
  mixins: [PageMetaMixin],
  beetPage: 'hunt_privacy',
  components: { TitleContentPage },
}
</script>
